import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  signin: {
    isLoading: false,
    receivedAt: null,
    isLogged: null,
    jwt: '',
    jwtPayload: {
      user: {
        tipo: '',
        nome: '',
        usuario: '',
        entityName: '',
      }
    },
    error: null,
    success: null,
  },
  signinProtocol: {
    isLoading: false,
    receivedAt: null,
    error: null,
  },
  signinValidateDoc: {
    isLoading: false,
    receivedAt: null,
    error: null,
    data: null,
  },
  signupVerify: {
    isLoading: false,
    error: null,
    success: null,
  },
  signup: {
    isLoading: false,
    error: null,
    success: null,
  },
  plans: {
    isLoading: false,
    data: [],
  },
  plan: {
    isLoading: false,
    data: null,
    error: null,
  },
  signupMedico: {
    isLoading: false,
    error: null,
    success: null,
  },
  recoveryPasswd: {
    isLoading: false,
    error: null,
    success: null,
  },
  changePasswd: {
    isLoading: false,
    error: null,
  },
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.REQUEST_SIGN_IN:
    case types.RECEIVE_SIGN_IN:
      return {
        ...state,
        signin: {
          isLoading: action.isLoading,
          receivedAt: action.receivedAt,
          isLogged: action.isLogged,
          jwt: action.jwt,
          jwtPayload: action.jwtPayload,
          error: action.error,
        }
      }
    case types.RESET_SIGN_IN:
      return {
        ...state,
        signin: {
          ...state.signin,
          error: INITIAL_STATE.signin.error,
          success: INITIAL_STATE.signin.success,
        }
      }
    case types.REQUEST_SIGN_IN_PROTOCOL:
    case types.RECEIVE_SIGN_IN_PROTOCOL:
      return {
        ...state,
        signinProtocol: {
          isLoading: action.isLoading,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.RESET_SIGN_IN_PROTOCOL:
      return {
        ...state,
        signinProtocol: INITIAL_STATE.signinProtocol,
      }
    case types.REQUEST_SIGN_IN_VALIDATE_DOC:
    case types.RECEIVE_SIGN_IN_VALIDATE_DOC:
      return {
        ...state,
        signinValidateDoc: {
          isLoading: action.isLoading,
          receivedAt: action.receivedAt,
          error: action.error,
          data: action.data,
        }
      }
    case types.RESET_SIGN_IN_VALIDATE_DOC:
      return {
        ...state,
        signinValidateDoc: INITIAL_STATE.signinValidateDoc,
      }
    case types.REQUEST_SIGN_UP_VERIFY:
    case types.RECEIVE_SIGN_UP_VERIFY:
      return {
        ...state,
        signupVerify: {
          isLoading: action.isLoading,
          error: action.error,
          success: action.success,
        }
      }
    case types.REQUEST_SIGN_UP:
    case types.RECEIVE_SIGN_UP:
      return {
        ...state,
        signup: {
          isLoading: action.isLoading,
          error: action.error,
          success: action.success,
        }
      }
    case types.RESET_SIGN_UP:
      return {
        ...state,
        signup: INITIAL_STATE.signup
      }
    case types.REQUEST_PLANS:
    case types.RECEIVE_PLANS:
      return {
        ...state,
        plans: {
          isLoading: action.isLoading,
          data: action.data,
        }
      }
    case types.REQUEST_PLAN:
    case types.RECEIVE_PLAN:
      return {
        ...state,
        plan: {
          isLoading: action.isLoading,
          data: action.data,
          error: action.error,
        }
      }
    case types.RESET_PLAN:
      return {
        ...state,
        plan: INITIAL_STATE.plan
      }
    case types.REQUEST_SIGN_UP_MEDICO:
    case types.RECEIVE_SIGN_UP_MEDICO:
      return {
        ...state,
        signupMedico: {
          isLoading: action.isLoading,
          error: action.error,
          success: action.success,
        }
      }
    case types.RESET_SIGN_UP_MEDICO:
      return {
        ...state,
        signupMedico: INITIAL_STATE.signupMedico
      }
    case types.REQUEST_RECOVERY_PASSWD:
    case types.RECEIVE_RECOVERY_PASSWD:
      return {
        ...state,
        recoveryPasswd: {
          isLoading: action.isLoading,
          error: action.error,
          success: action.success,
        }
      }
    case types.RESET_RECOVERY_PASSWD:
      return {
        ...state,
        recoveryPasswd: INITIAL_STATE.recoveryPasswd
      }
    case types.REQUEST_CHANGE_PASSWD:
    case types.RECEIVE_CHANGE_PASSWD:
      return {
        ...state,
        changePasswd: {
          isLoading: action.isLoading,
          error: action.error,
        }
      }
    default:
      return state
  }
}
